export default "__VITE_ASSET__CpysNs9w__"